import { render, staticRenderFns } from "./games.vue?vue&type=template&id=6f0d1f44&"
import script from "./games.vue?vue&type=script&lang=js&"
export * from "./games.vue?vue&type=script&lang=js&"
import style0 from "./games.vue?vue&type=style&index=0&id=6f0d1f44&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f0d1f44')) {
      api.createRecord('6f0d1f44', component.options)
    } else {
      api.reload('6f0d1f44', component.options)
    }
    module.hot.accept("./games.vue?vue&type=template&id=6f0d1f44&", function () {
      api.rerender('6f0d1f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/components/games.vue"
export default component.exports